import ChatContext, { chatDataContextInitialStates } from "@/context/chatContext";
import { useState } from "react";
import ChatPage from "./page";

const PadreChat = () => {
    const [chatData, setChatData] = useState(chatDataContextInitialStates);

    return (
        <ChatContext.Provider value={{ chatData, setChatData }}>
            <ChatPage />
        </ChatContext.Provider>
    );
}

export default PadreChat;
